(function(angular) {
    angular.module('bizPartEngage').controller('modules.educations', indexController);
    angular.module('bizPartEngage').controller('modules.educations.html5', html5Controller);

    indexController.$inject = ["modules.education.service", "$state", "$stateParams", "container", "$filter", "$translate", "MetadataService", "bizEngageService"];
    html5Controller.$inject = ["$rootScope", "$scope", "$q", "modules.education.service", "BizOnlineEducationReplyService", "$stateParams", "container", 
        "bizContainerSettings", "$translate", "MetadataService", "bizEngageService", "core.engage.service"];

    function indexController(educationService, $state, $stateParams, container, $filter, $translate, MetadataService, bizEngageService) {
        var vm = this;
        vm.TagId = ~~$stateParams.tagId;
        vm.TagSystemName = $stateParams.tagSystemName;

        function GetTag() {
            if (vm.TagSystemName) {
                educationService.GetTagBySystemName(vm.TagSystemName).then(GetTagSuccess);
            } else if (vm.TagId) {
                educationService.GetTag(vm.TagId).then(GetTagSuccess);
            } 

            function GetTagSuccess(response) {
                vm.SelectedTag = vm.TagSystemName ? response.data : response.data[0];
                vm.TagId = vm.SelectedTag.Id;
            }
        }

        angular.element(document).ready(function () {
            $translate(['EDUCATION.META.TITLE', 'EDUCATION.META.DESCRIPTION']).then(function (translations) {
                MetadataService.setMetaTags({
                    title: translations['EDUCATION.META.TITLE'],
                    description: translations['EDUCATION.META.DESCRIPTION']
                })
            });
        });

        vm.$onInit = function () {
            GetTag();
            bizEngageService.GetMiniJourneySetting('HTML5').then(function (response) {                
                vm.MiniJourneySettings = response;
            });
        }
    }

    function html5Controller($rootScope, $scope, $q, educationService, replyService, $stateParams, container, 
        bizContainerSettings, $translate, MetadataService, bizEngageService, engageService) {
        var vm = this;
        vm.OnlineEducation = undefined;
        vm.ShowOnlineEducation = false;
        vm.ModulesRequiringFinish = [];
        vm.OnlineEducationId = ~~$stateParams.id;
        vm.OnlineEducationFinished = false;

        bizContainerSettings.ContainerRefererType = "HTML5";
        bizContainerSettings.ContainerRefererObjectId = vm.OnlineEducationId;        

        vm.GetOnlineEducation = GetOnlineEducation;

        function GetOnlineEducation() {
            if (vm.OnlineEducationId > 0) {
                $q.all([
                    educationService.GetHTML5Education(vm.OnlineEducationId),
                    educationService.GetHTML5EducationReply(vm.OnlineEducationId)
                ]).then(GetOnlineEducationSuccess, GetOnlineEducationError);
            }
            else {
                vm.OnlineEducationId = $stateParams.id;

                educationService.GetHTML5EducationByUrlRewrite(vm.OnlineEducationId).then(function(response) {
                    vm.OnlineEducation = response.data;    
                    bizContainerSettings.ContainerRefererCreatedByUserId = vm.OnlineEducation.CreatedByUserId;

                    vm.OnlineEducation.Container = new container(vm.OnlineEducation.Container);
                    vm.OnlineEducation.Container.setModuleFinishHandler(ModuleFinishHandler);

                    var modulesWithSettings = vm.OnlineEducation.Container.getModulesWithSettings();

                    bizEngageService.HandleContainer(vm.OnlineEducation.Container, vm.OnlineEducation.Id, bizEngageService.Types.HTML5);
                    
                    educationService.GetHTML5EducationReply(vm.OnlineEducation.Id).then(function(reply) {
                        replyService.OnlineEducationReply = reply.data;
                        replyService.UserStatus = vm.OnlineEducation.UserStatus;

                        if(replyService.UserStatus) {
                            for (var i = 0; i < replyService.UserStatus.length; i++) {
                                if (replyService.UserStatus[i].IsFinished === true) {
                                    var mod = modulesWithSettings.GetItemByValue('Id', replyService.UserStatus[i].ContainerModuleInstanceId);
                                    if (mod) {
                                        mod.IsFinished = true;
                                    }
                                }
                            }
                        }

                        vm.ShowOnlineEducation = true;
                    });
                });
            }

            function GetOnlineEducationError(err) {
                if(err.status == 401)
                    vm.NoAccess = true;
            }

            function GetOnlineEducationSuccess(response) {
                vm.OnlineEducation = response[0].data;                
                bizContainerSettings.ContainerRefererCreatedByUserId = vm.OnlineEducation.CreatedByUserId;

                replyService.OnlineEducationReply = response[1].data;
                replyService.UserStatus = vm.OnlineEducation.UserStatus;

                vm.OnlineEducation.Container = new container(vm.OnlineEducation.Container);
                vm.OnlineEducation.Container.setModuleFinishHandler(ModuleFinishHandler);

                var modulesWithSettings = vm.OnlineEducation.Container.getModulesWithSettings();
                for (var i = 0; i < replyService.UserStatus.length; i++) {
                    if (replyService.UserStatus[i].IsFinished === true) {
                        var mod = modulesWithSettings.GetItemByValue('Id', replyService.UserStatus[i].ContainerModuleInstanceId);
                        if (mod) {
                            mod.IsFinished = true;
                        }

                    }
                }

                vm.ShowOnlineEducation = true;

                bizEngageService.HandleContainer(vm.OnlineEducation.Container, vm.OnlineEducation.Id, bizEngageService.Types.HTML5);
            }
        }

        function ModuleFinishHandler(module) {
            educationService.HTML5ModuleInstanceFinished(replyService.OnlineEducationReply.Id, module.Id).then(ModuleInstanceFinishedSuccess);

            function ModuleInstanceFinishedSuccess(response) {
            	$rootScope.$broadcast('QUESTION_MODULE_RESULT', { module: module, result: response.data });
            	var modules = vm.OnlineEducation.Container.getModulesWithSettings();
            	var unfinished = modules.GetItemsByValue("IsFinished", false);
                if (unfinished.length == 0 && !vm.IsSubmitted) {
                    educationService.SubmitHTML5Education(replyService.OnlineEducationReply.Id).then(SubmitEducationSuccess);
                    vm.IsSubmitted = true;//prevent double submission when last module is within a segment, because both the last module and segment will trigger finish events
                }

                function SubmitEducationSuccess(response) {
                    $rootScope.$broadcast('EDUCATION_FINISHED', response.data);
                    if (response.data.Success) {
                        $rootScope.$broadcast('EDUCATION_FINISHED_SUCCESS', response.data);
                        vm.OnlineEducationFinished = true;
                        //$timeout(vm.ShowForm, 2500);
                    }
                    else {
                        $rootScope.$broadcast('EDUCATION_FINISHED_FAILED', response.data);
                    }
                }
            }
        }

        vm.$onInit = function() {
            vm.GetOnlineEducation();

            bizEngageService.GetMiniJourneySetting('HTML5').then(function (response) {
                vm.MiniJourneySettings = response;
            });
        }

        angular.element(document).ready(function () {
            $translate(['EDUCATION.META.TITLE', 'EDUCATION.META.DESCRIPTION']).then(function (translations) {
                MetadataService.setMetaTags({
                    title: translations['EDUCATION.META.TITLE'],
                    description: translations['EDUCATION.META.DESCRIPTION']
                })
            });
        });                
    }

})(window.angular);
